module.exports = __webpack_public_path__ + "img/paragraph.454b7728.svg";